import React, { useEffect, useState } from 'react';
import { listThreads } from './api';
import { COPY } from './copy';
import MessageList from './MessageList';

const HEADER_FOR = {
  specialist_to_gp: { label: 'SPECIALIST → GP', color: COPY.hex.alertRed },
  gp_to_specialist: { label: 'GP → SPECIALIST', color: COPY.hex.closedBlue },
};

// Admin-only read-only summary of every RAI thread on an issue (story
// #28337). Admin sees both directions, both states, with full message
// history and attachments. No composer, no open-request button.
const AdminRequestThreadView = ({ issue }) => {
  const [threads, setThreads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    listThreads(issue.id)
      .then((data) => { if (!cancelled) setThreads(data || []); })
      .catch((err) => {
        if (cancelled) return;
        if (err.response?.status === 403 || err.response?.status === 404) {
          setLoadFailed(false);
        } else {
          setLoadFailed(true);
        }
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [issue.id]);

  if (loading) return null;
  if (loadFailed) {
    return <p className="text-sm text-red-600">Could not load request threads.</p>;
  }
  if (!threads.length) {
    return (
      <div className="bg-white rounded shadow mb-4 p-3 text-sm text-slate-500">
        No additional-information requests on this issue.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-y-3 mb-4">
      <h3 className="font-semibold uppercase text-sm text-slate-700">Request Additional Information — Admin View</h3>
      {threads.map((t) => {
        const header = HEADER_FOR[t.direction] || { label: t.direction, color: COPY.hex.alertRed };
        const stateChip = t.state === 'open' ? 'OPEN' : `AUTO-CLOSED (${t.auto_closed_reason || 'unknown'})`;
        return (
          <div key={t.id} className="bg-white rounded shadow">
            <div
              className="font-semibold uppercase text-sm text-white px-3 py-2 rounded-t flex flex-row justify-between"
              style={{ backgroundColor: header.color }}
            >
              <span>{header.label}</span>
              <span>{stateChip}</span>
            </div>
            <div className="border border-t-0 border-gray-200 rounded-b p-3 bg-slate-50">
              <MessageList messages={t.messages} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AdminRequestThreadView;
